import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/style/index.scss' // global css
// 引入lib-flexible 用于设置rem基准值
import 'lib-flexible/flexible'
// 引入vant组件
import {
  Lazyload, Field, CellGroup, Popup, Cell, Area, Col, Row, Toast, RadioGroup, Radio
} from 'vant'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.config.productionTip = false
Vue.use(VideoPlayer)
Vue.use(Lazyload)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(Popup)
Vue.use(Cell)
Vue.use(Area)
Vue.use(Col)
Vue.use(Row)
Vue.use(Toast)
Vue.use(RadioGroup)
Vue.use(Radio)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
